import { FC, ReactNode } from 'react';
import { FormProvider } from 'react-hook-form';
import { UsePersonFormArgs, usePersonForm } from '../hooks';
import { PersonFormContextProvider } from './../context/personForm.context';

interface PersonFormProps extends UsePersonFormArgs {
  children?: ReactNode;
  className?: HTMLFormElement['className'];
}

export const PersonForm: FC<PersonFormProps> = ({ children, className, ...usePersonFormArgs }) => {
  const { formMethods, onSubmit } = usePersonForm({ ...usePersonFormArgs });

  return (
    <FormProvider {...formMethods}>
      <PersonFormContextProvider person={usePersonFormArgs.person}>
        <form className={className} onSubmit={formMethods.handleSubmit(onSubmit)}>
          {children}
        </form>
      </PersonFormContextProvider>
    </FormProvider>
  );
};
